import { getValidationLogic } from './getValidationLogic'

const financial = () => {
  return {
    bank_iban: {
      presence: {
        allowEmpty: getValidationLogic('transaction', 'financial', 'bank_iban', 'allowEmpty'),
        message: '^inputError.blankField'
      },
      length: {
        is: Number(getValidationLogic('transaction', 'financial', 'bank_iban', 'len', 'default')),
        message: '^inputError.invalidIban'
      },
      format: {
        pattern: getValidationLogic('transaction', 'financial', 'bank_iban', 'pattern', 'default'),
        message: '^inputError.invalidIban'
      }
    },
    bank_card_number: {
      presence: {
        allowEmpty: getValidationLogic('transaction', 'financial', 'bank_card_number', 'allowEmpty', 'default'),
        message: '^inputError.blankField'
      },
      length: {
        is: Number(getValidationLogic('transaction', 'financial', 'bank_card_number', 'len', 'default')),
        message: '^inputError.invalidCardNum'
      }
      // format: {
      //   pattern: getValidationLogic('transaction', 'financial', 'card', 'pattern'),
      //   message: '^inputError.invalidCardNum'
      // }
    }
  }
}

export default financial
